import { useEffect, useState, FC } from "react";

import "./dev.scss";
import { postOrg, RubiOrgModel, listOrg } from "@rubi/api-generated";
import { Link } from "react-router-dom";

import { Breadcrumbs, Crumb, DevPage, ErrorMsg, Section } from "./common";

const OrgRow: FC<RubiOrgModel> = (org) => {
  return (
    <tr>
      <td className="mono">
        <Link to={"./" + org.id} state={{ org }}>
          {org.id}
        </Link>
      </td>
      <td className="mono muted">{org.time_created}</td>
      <td className="mono muted">{org.time_updated}</td>
      <td>{org.title}</td>
      <td>{org.short_title ?? <span className="muted">—</span>}</td>
    </tr>
  );
};

const OrgTable: FC<{ orgs: RubiOrgModel[] }> = ({ orgs }) => {
  return (
    <table className="dev-table">
      <thead>
        <tr>
          <th>id</th>
          <th>time_created</th>
          <th>time_updated</th>
          <th>title</th>
          <th>short_title</th>
        </tr>
      </thead>
      <tbody>
        {orgs.map((org) => (
          <OrgRow key={org.id} {...org} />
        ))}
      </tbody>
    </table>
  );
};

export const DevOrgsPage: FC = () => {
  const [orgsList, setOrgsList] = useState<RubiOrgModel[]>([]);
  const [laodOrgsErrorMsg, setLoadOrgsErrorMsg] = useState<string | null>(null);
  const [createOrgTitle, setCreateOrgTitle] = useState<string>("1");
  const [createOrgShortTitle, setCreateOrgShortTitle] = useState<string>("");
  const [createOrgErrorMsg, setCreateOrgErrorMsg] = useState<string>("");

  const loadOrgs = async () => {
    const response = await listOrg({ throwOnError: false });
    if (response.status === 200) {
      const data = response.data!;
      setOrgsList(data);
      setLoadOrgsErrorMsg(null);
    } else {
      setOrgsList([]);
      setLoadOrgsErrorMsg(
        "" + response.status + " " + response.error?.console_msg,
      );
    }
  };

  const doCreateOrg = async (title: string, shortTitle: string) => {
    const response = await postOrg({
      body: { title, short_title: shortTitle },
      throwOnError: false,
    });
    if (response.status !== 200) {
      setCreateOrgErrorMsg(
        "" + response.status + " " + response.error?.console_msg,
      );
    }
  };

  useEffect(() => {
    loadOrgs();
  }, []);

  return (
    <DevPage
      title="Orgs"
      breadcrumbs={
        <Breadcrumbs>
          <Crumb>
            <Link to="/">Home</Link>
          </Crumb>
          <Crumb>
            <Link to="/dev_admin">Developer and Administrator Utilities</Link>
          </Crumb>
          <Crumb>Orgs</Crumb>
        </Breadcrumbs>
      }
    >
      <Section subtitle="Create org">
        <span>Title: </span>
        <input
          value={createOrgTitle}
          onChange={(e) => setCreateOrgTitle(e.target.value)}
        />
        <span>Short title: </span>
        <input
          value={createOrgShortTitle}
          onChange={(e) => setCreateOrgShortTitle(e.target.value)}
        />
        <button
          onClick={() => doCreateOrg(createOrgTitle, createOrgShortTitle)}
        >
          Create
        </button>
        <ErrorMsg msg={createOrgErrorMsg} />
      </Section>
      <Section>
        <button onClick={loadOrgs}>Reload</button>
        <ErrorMsg msg={laodOrgsErrorMsg} />
        <OrgTable orgs={orgsList} />
      </Section>
    </DevPage>
  );
};
